import { _ } from 'core-js'

export class EnumType {
  #itemsArray;
  #itemsMap;
  #label;
  #icon;

  constructor (items, label, icon) {
    const itemsArray = []
    if (Array.isArray(items)) {
      for (const item of items) {
        const freezedItem = Object.freeze({
          text: item.name,
          textPy: item.name,
          ...item
        })
        itemsArray.push(freezedItem)
      }
    } else {
      for (const name in items) {
        const freezedItem = Object.freeze({
          name: name,
          text: name,
          textPy: name,
          ...items[name]
        })
        itemsArray.push(freezedItem)
      }
    }
    this.#itemsArray = Object.freeze(itemsArray)
    this.#itemsMap = Object.freeze(
      new Map([
        ...itemsArray.map(item => [item.text, item]),
        ...itemsArray.map(item => [item.name, item]),
        ...itemsArray.map(item => [item.value, item]),
        ...itemsArray.map(item => [String(item.value), item])
      ])
    )
    this.#label = label ?? this.constructor.name
    this.#icon = icon
  }

  get items () {
    return this.#itemsArray
  }

  get label () {
    return this.#label
  }

  get icon () {
    return this.#icon
  }

  getItem (token) {
    return this.#itemsMap.get(token)
  }

  getItemValue (token) {
    return this.getItem(token)?.value
  }

  getItemName (token, options) {
    const name = this.getItem(token)?.name
    if (name && options) {
      if (options.camelCase) {
        return _.camelCase(name)
      }
      if (options.kebabCase) {
        return _.kebabCase(name)
      }
    }
    return name
  }

  getItemText (token) {
    return this.getItem(token)?.text
  }

  getItemTextPy (token) {
    return this.getItem(token)?.textPy
  }

  getItemIcon (token) {
    return this.getItem(token)?.icon
  }

  getItemColor (token) {
    return this.getItem(token)?.color
  }

  getItemMeta (token) {
    return this.getItem(token)?.meta
  }
}
